<script>
import Base from '@/plans/ZOOM_WHITEBOARD/config/base';
import { isLastPlanTypeInPlantypeList } from '@/utils/index.js';

export default {
  extends: Base,
  computed: {
    canRmv() {
      return this.$context.is.winback
        ? !isLastPlanTypeInPlantypeList(
            this.planType,
            this.getSelectedPlans.map((p) => p.type),
          )
        : this.$context.type !== this.planType;
    },
  },
};
</script>
